import React, { useEffect, useState } from 'react';
import { Form, Checkbox, message, Col, Row } from 'antd';
import LoadingButton from '../../components/LoadingButton';
import { useSelector } from 'react-redux';
import CustomSelectOptions from '../../components/formComponents/CustomSelectOptions';
import _, { get } from 'lodash';
import { getPermissionGroups } from '../../utils/permissionGroup';
type EditPermissionComponentProp = {
  initialValue?: any;
  onSubmit: (values: any) => Promise<void>;
  loading: boolean;
};

const EditPermissionComponents: React.FC<EditPermissionComponentProp> = ({
  initialValue,
  onSubmit,
  loading,
}) => {
  const [form] = Form.useForm();
  const { role } = useSelector((state: any) => state.role);
  const [checkedPermissions, setCheckedPermissions] = useState<string[]>(initialValue?.permissions || []);
  const permissionGroups = getPermissionGroups('tenant') as any;
    const [indeterminate, setIndeterminate] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [disableCheckboxes, setDisableCheckboxes] = useState(false);
  const onCheckAllChange = (e: any) => {
    const allPermissions = Object.values(permissionGroups).flat();
    const checked = e.target.checked;
    const newChecked = checked ? allPermissions : [] as any;
    setCheckedPermissions(newChecked);
    form.setFieldsValue({ permissions: newChecked });
    setSelectAll(checked);
    setIndeterminate(false);
  };

  const handleSubmit = async (values: any) => {
    try {
      await onSubmit({ ...values, permissions: checkedPermissions });
      message.success('Permissions updated successfully!');
    } catch (error) {
      message.error('Error updating permissions');
    }
  };

  const onChange = (checkedValues: string[]) => {
    setCheckedPermissions(checkedValues);
  };

  useEffect(() => {
        const allPermissions = Object.values(permissionGroups).flat();
        setSelectAll(checkedPermissions.length === allPermissions.length);
        setIndeterminate(
          checkedPermissions.length > 0 && checkedPermissions.length < allPermissions.length
        );
    }, [checkedPermissions, permissionGroups]);

  return (
    <Form
      form={form}
      name="basic"
      labelCol={{ span: 8 }}
      initialValues={{ ...initialValue }}
      onFinish={handleSubmit}
      autoComplete="off"
      layout="vertical"
    >
      {!role.role.includes('sub-tenant') && (
        <Form.Item
          label="Role"
          name={'role'}
          rules={[{ required: true, message: 'Please select role!' }]}
        >
          <CustomSelectOptions value={form.getFieldValue('role')} options={[
            { value: 'sub-tenant', label: 'Sub Tenant' },
            { value: 'support-tenant', label: 'Support Tenant' }
          ]}
            onChange={(val: any) => form.setFieldValue("role", val)}
          />
        </Form.Item>
      )}
      <Form.Item label="Permissions">
        <Checkbox
          indeterminate={indeterminate}
          onChange={onCheckAllChange}
          checked={selectAll}
          disabled={disableCheckboxes}
        >
          Check All
        </Checkbox>
      </Form.Item>

      <Form.Item
        name="permissions"
        rules={[{ required: true, message: 'Please select at least one permission!' }]}
      >
        <Checkbox.Group
          key={Object.keys(permissionGroups).join('-')} // forces re-render when permissionGroups change
          onChange={onChange}

        >
          <Row gutter={[16, 16]}>
            {Object.entries(permissionGroups).map(([group, permissions]: any) => (
              <Col span={8} key={group}>
                <div>
                  <p className="font-semibold mb-2 text-gray-900">{group}</p>
                  {permissions.map((permission: string) => (
                    <Col span={24} key={permission}>
                      <Checkbox value={permission} >
                        {_.startCase(permission.replace('destroy', 'delete'))}
                      </Checkbox>
                    </Col>
                  ))}
                </div>
              </Col>
            ))}
          </Row>
        </Checkbox.Group>
      </Form.Item>

      <Form.Item>
        <LoadingButton loading={loading} title="Update" />
      </Form.Item>
    </Form>
  );
};

export default EditPermissionComponents;
